import { Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from '@/components/ui/toaster'
import Navigation from '@/components/Navigation'
import Landing from '@/pages/Landing'
import Config from '@/pages/Config'
import Stream from '@/pages/Stream'
import Logs from '@/pages/Logs'

function App() {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/demo" element={<Navigate to="/demo/config" replace />} />
          <Route path="/demo/config" element={<Config />} />
          <Route path="/demo/stream" element={<Stream />} />
          <Route path="/demo/logs" element={<Logs />} />
        </Routes>
      </main>
      <Toaster />
    </div>
  )
}

export default App
